<template>
  <div class="spotlight-with-search relative lg:grid lg:grid-cols-2 lg:gap-10 xl:overflow-hidden max-w-[2000px] mx-auto">
    <SpotlightImages
      v-if="component.Images.length > 0"
      :images="component.Images"
      :index="index"
      class="lg:col-start-2"
    />
    <div class="flex flex-col lg:col-start-1 lg:row-start-1">
      <div
        class="spotlight-with-search__content container container--page-content pt-0 pb-10 md:py-10 flex flex-col gap-2 md:gap-10 lg:py-20 lg:px-16"
      >
        <h1 class="lg:hyphens-none lg:text-[58px]">{{ component.spotlightTitle }}</h1>
        <div class="flex flex-col gap-4 md:gap-6">
          <div class="spotlight-with-search__content-description">
            <div
              v-if="component.description"
              v-html="component.description"
              class="text-regular-normal lg:text-medium-normal"
            ></div>
          </div>
          <div v-if="component.ctas?.length" class="flex flex-wrap gap-4">
            <SharedButton
              v-for="(cta, i) in component.ctas"
              :key="i"
              :variant="cta.type"
              :label="cta.text || ''"
              :to="cta.target || cta.page?.slug || ''"
            />
          </div>
        </div>
      </div>
      <div
        ref="searchRef"
        class="spotlight-with-search__search container container--page-content py-6 flex flex-col gap-4 bg-neutral-lightest spotlight-with-search__search--enter lg:px-16"
      >
        <div class="h5 text-2xl mb-2">{{ t('components.spotlight-with-search.searchTitle') }}</div>
        <Search />
        <AISearch autoType />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { GraphQLSpotlightWithSearch } from '~/types/graphql';
  import { useElementVisibility } from '@vueuse/core';

  import SpotlightImages from './SpotlightImages/index.vue';
  import Search from './Search/index.vue';

  const { component } = defineProps<{
    component: GraphQLSpotlightWithSearch;
    index: number;
  }>();

  const { t } = useI18n();

  const searchRef = useTemplateRef<HTMLElement | null>('searchRef');
  const isVisible = useElementVisibility(searchRef, {
    rootMargin: '0px 0px -100px 0px',
  });

  // Handle animation on mount
  onMounted(() => {
    if (!searchRef.value) return;

    // If element is already visible, trigger animation immediately
    if (isVisible.value) {
      searchRef.value.classList.add('spotlight-with-search__search--visible');
      return;
    }

    // Add inactive class for animation if element is not visible
    searchRef.value.classList.add('spotlight-with-search__search--inactive');
  });

  // Watch for visibility changes and trigger animation
  watch(isVisible, visible => {
    if (visible && searchRef.value) {
      searchRef.value.classList.remove('spotlight-with-search__search--inactive');
      searchRef.value.classList.add('spotlight-with-search__search--visible');
    }
  });
</script>

<style lang="scss" scoped>
  // .spotlight-with-search__search {
  //   &--enter {
  //     opacity: 0;
  //     transition: opacity 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  //   }

  //   &--inactive {
  //     opacity: 0;
  //   }

  //   &--visible {
  //     opacity: 1;
  //   }
  // }
</style>
